import type { SxProps, Theme } from '@mui/material';

export const cardsContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const table: SxProps<Theme> = {
  tableLayout: 'fixed',
  width: '100%',
};

export const headerCell: SxProps<Theme> = {
  border: 'none',
  padding: 2,
};

export const headerCellTitle: SxProps<Theme> = {
  ...headerCell,
  width: '50%',
};

export const headerCellAlbum: SxProps<Theme> = {
  ...headerCell,
  width: '25%',
};

export const headerCellDuration: SxProps<Theme> = {
  ...headerCell,
  width: '15%',
  textAlign: 'left',
  pl: 2,
};

export const headerCellActions: SxProps<Theme> = {
  ...headerCell,
  width: '10%',
  textAlign: 'right',
};

export const headerLabel: SxProps<Theme> = {
  color: 'text.secondary',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
};

export const cardPaper: SxProps<Theme> = {
  borderRadius: 1,
  overflow: 'hidden',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    boxShadow: 2,
  },
};

export const cardCell: SxProps<Theme> = {
  border: 'none',
  padding: 2,
};

export const cardCellTitle: SxProps<Theme> = {
  ...cardCell,
  width: '50%',
};

export const cardCellAlbum: SxProps<Theme> = {
  ...cardCell,
  width: '25%',
};

export const cardCellDuration: SxProps<Theme> = {
  ...cardCell,
  width: '15%',
  textAlign: 'left',
  pl: 2,
  fontVariantNumeric: 'tabular-nums',
};

export const cardCellActions: SxProps<Theme> = {
  ...cardCell,
  width: '10%',
  textAlign: 'right',
};

export const artworkContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

export const artworkImageWrapper: SxProps<Theme> = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 48,
  height: 48,
  borderRadius: 1,
  backgroundColor: 'grey.100',
  overflow: 'hidden',
};

export const artworkImage: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

export const artworkPlaceholder: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: 'grey.200',
};

export const playButton = (isPlaying: boolean): SxProps<Theme> => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: isPlaying ? 'primary.main' : 'rgba(0, 0, 0, 0.7)',
  color: 'white',
  width: 32,
  height: 32,
  opacity: isPlaying ? 1 : 0,
  transition: 'opacity 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: isPlaying ? 'primary.dark' : 'rgba(0, 0, 0, 0.8)',
  },
  '.MuiPaper-root:hover &': {
    opacity: 1,
  },
});

export const playPauseIcon: SxProps<Theme> = {
  fontSize: 20,
};

export const titleContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const title: SxProps<Theme> = {
  fontWeight: 500,
  lineHeight: 1.2,
  marginBottom: 0.5,
};

export const actionsContainer: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  justifyContent: 'flex-end',
};

export const findSimilarButton: SxProps<Theme> = {
  fontSize: '0.75rem',
  minWidth: 'auto',
};

export const newChip: SxProps<Theme> = {
  fontSize: '0.75rem',
  height: 20,
  backgroundColor: 'primary.50',
  color: 'primary.main',
  borderColor: 'primary.200',
};
